<script setup lang="ts">
  import { computed, inject } from 'vue';
  import Tooltip from '../Tooltip/Tooltip.vue';
  import { appVersionClass, toneVariants } from './AppVersion.css';
  import { AppVersionTone, type AppVersionProps } from './AppVersion.types';

  const props = withDefaults(defineProps<AppVersionProps>(), {
    collapsed: false,
    tone: AppVersionTone.Default,
  });

  const injectedVersion = inject<string>('appVersion', '');

  const version = computed(() => props.version ?? injectedVersion);
</script>

<template>
  <Tooltip v-if="version" :title="collapsed ? version : ''">
    <div
      :class="[appVersionClass, toneVariants[tone]]"
      :title="version"
      :data-testid="testId"
    >
      v. {{ version }}
    </div>
  </Tooltip>
</template>
